import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const BreadcrumbSchema = () => {
  const location = useLocation();
  const pathname = location.pathname;

  // Build segments from the URL path
  const segments = pathname
    .split("/")
    .filter(Boolean)
    .map((segment, index, arr) => {
      const path = "/" + arr.slice(0, index + 1).join("/");
      const name = segment.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase());
      return { name, path };
    });

  const breadcrumbItems = [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.skyazul.com/"
    },
    ...segments.map((seg, i) => ({
      "@type": "ListItem",
      position: i + 2,
      name: seg.name,
      item: `https://www.skyazul.com${seg.path}`
    }))
  ];

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": breadcrumbItems
        })}
      </script>
    </Helmet>
  );
};

export default BreadcrumbSchema;
